import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
  // mode: 'history', 
  routes: [{
    path: '/',
    name: 'Index',
    component:resolve => require(['@/Index'], resolve),
    // component: Index,
    meta: {
        requireAuth: true,
        keepAlive: true // 用户列表需要被缓存
    }
  }, 
//enroll 
{ 
  path: '/EnrollView',
  name: 'EnrollView',
  component:resolve => require(['@/view/enroll/EnrollView'], resolve),
},
  {
    path: '/ToExamine',
    name: 'ToExamine',
    component:resolve => require(['@/view/enroll/ToExamine'], resolve),
  },
  {
    path: '/ViewInvoice',
    name: 'ViewInvoice',
    component:resolve => require(['@/view/enroll/ViewInvoice'], resolve),
  },
  {
    path: '/PaymentOk',
    name: 'PaymentOk',
    component:resolve => require(['@/view/enroll/PaymentOk'], resolve),
  },
  {
    path: '/FaceCourse',
    name: 'FaceCourse',
    component:resolve => require(['@/view/enroll/FaceCourse'], resolve),
  },
  {
    path: '/ChoiceCourse',
    name: 'ChoiceCourse',
    component:resolve => require(['@/view/enroll/ChoiceCourse'], resolve),
  },
  {
    path: '/EnrollMessage',
    name: 'EnrollMessage',
    component:resolve => require(['@/view/enroll/EnrollMessage'], resolve),
  },
  {
    path: '/PaymentView',
    name: 'PaymentView',
    component:resolve => require(['@/view/enroll/PaymentView'], resolve),
  },//enroll end
  {
    path: '/NewsDetail',
    name: 'NewsDetail',
    component:resolve => require(['@/view/news/NewsDetail'], resolve),
  },//news end
  { //news admin
    path: '/LoginView',
    name: 'LoginView',
    component:resolve => require(['@/view/LoginView'], resolve),
  },
  {
    path: '/RegisterView',
    name: 'RegisterView',
    component:resolve => require(['@/view/admin/RegisterView'], resolve),
  },
  {
    path: '/ProblemView',
    name: 'ProblemView',
    component:resolve => require(['@/view/admin/ProblemView'], resolve),
  },
  {
    path: '/ResetPwd',
    name: 'ResetPwd',
    component:resolve => require(['@/view/admin/ResetPwd'], resolve),
  },
  {
    path: '/NewPwd',
    name: 'NewPwd',
    component:resolve => require(['@/view/admin/NewPwd'], resolve),
  },
  {
    path: '/CourseDetail',
    name: 'CourseDetail',
    component:resolve => require(['@/view/admin/CourseDetail'], resolve),
  },
  {
    path: '/OnlineTest',
    name: 'OnlineTest',
    component:resolve => require(['@/view/admin/OnlineTest'], resolve),
  },
  {// 
    path: '/EnrollCard',
    name: 'EnrollCard',
    component:resolve => require(['@/view/enroll/EnrollCard'], resolve),
  },
  { // 学分查询
    path: '/CreditInquiry',
    name: 'CreditInquiry',
    component:resolve => require(['@/view/admin/CreditInquiry'], resolve),
  },
  { // admin 个人信息
    path: '/InformationView',
    name: 'InformationView',
    component:resolve => require(['@/view/admin/InformationView'], resolve),
  },
  { // 发票
    path: '/InvoiceView',
    name: 'InvoiceView',
    component:resolve => require(['@/view/admin/InvoiceView'], resolve),
  },
  {
    path: '/Content',
    name: 'Content',
    component:resolve => require(['@/Content'], resolve),
    redirect: {name:'UserCenter'},
    children: [
      {// 用户中心
        path: 'UserCenter',
        name: 'UserCenter',
        component:resolve => require(['@/view/admin/UserCenter'], resolve),
      },
      { // 课程列表
        path: 'CourseList',
        name: 'CourseList',
        component:resolve => require(['@/view/admin/CourseList'], resolve),
      }
    ]
  }
  ]
})
// export 



// WEBPACK FOOTER //
// ./src/router/index.js